import { html } from 'lit';
import { SquarePen } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-pen-square')
export class PdsIconPenSquare extends PdsIcon {
  @state()
  icon = SquarePen;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
